import { render, staticRenderFns } from "./InstructorRoleInlineForm.vue?vue&type=template&id=d0dba3b6"
import script from "./InstructorRoleInlineForm.vue?vue&type=script&lang=js"
export * from "./InstructorRoleInlineForm.vue?vue&type=script&lang=js"
import style0 from "./InstructorRoleInlineForm.vue?vue&type=style&index=0&id=d0dba3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports